import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Disclaimer = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F0F4FF] to-[#E6F0FF] text-gray-800">
      {/* Geometric background elements */}
      <div className="absolute inset-0 overflow-hidden opacity-20 pointer-events-none">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#7000FF] rounded-full filter blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#00FFC6] rounded-full filter blur-3xl translate-x-1/2 translate-y-1/2"></div>
      </div>

      {/* Navigation */}
      <nav className="relative z-10 px-6 py-6 flex justify-between items-center">
        <motion.div 
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          className="flex items-center"
        >
          <span className="text-2xl font-bold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-[#7000FF] to-[#00FFC6]">
            ABMR Holdings
          </span>
          <span className="ml-2 text-sm uppercase tracking-widest text-gray-600">Family Office</span>
        </motion.div>
        
        <motion.button
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          onClick={() => navigate('/')}
          className="px-5 py-2 rounded-full bg-gradient-to-r from-[#7000FF] to-[#00FFC6] text-white font-medium text-sm hover:shadow-lg hover:shadow-[#7000FF]/20 transition-all"
        >
          Back to Home
        </motion.button>
      </nav>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="bg-white rounded-xl shadow-sm p-8 md:p-12"
        >
          <h1 className="text-3xl md:text-4xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-[#7000FF] to-[#00FFC6]">Disclaimer</h1>
          
          <div className="prose max-w-none text-gray-700">
            <p className="mb-4">Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">1. General Information</h2>
            <p>
              The information contained on the ABMR Holdings website is for general information purposes only. ABMR Holdings assumes no responsibility for errors or omissions in the contents of the website. The information is provided "as is" with no guarantees of completeness, accuracy, usefulness, or timeliness.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">2. Not Financial Advice</h2>
            <p>
              The content of this website is not intended to be financial advice, nor does it constitute an offer to sell or the solicitation of an offer to purchase interests in any investment vehicle or the provision of any investment advisory or other services. The information on this website is not an advertisement for the private investment funds managed by ABMR Holdings.
            </p>
            <p>
              In no event shall ABMR Holdings be liable for any special, direct, indirect, consequential, or incidental damages or any damages whatsoever, whether in an action of contract, negligence, or other tort, arising out of or in connection with the use of the website or the contents of the website.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">3. Past Performance</h2>
            <p>
              Past performance is not indicative of future results. The value of investments and the income derived from them can go down as well as up. It is the responsibility of the individual investor to consider his or her investment objectives, risk tolerance, and financial circumstances before making any investment decision.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">4. Forward-Looking Statements</h2>
            <p>
              This website may contain forward-looking statements that are based on our current expectations, estimates, projections, and assumptions. These statements are not guarantees of future performance and involve certain risks and uncertainties, which are difficult to predict. Therefore, actual future results and trends may differ materially from what is forecast in forward-looking statements due to a variety of factors.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">5. External Links</h2>
            <p>
              This website may contain links to external websites that are not provided or maintained by or in any way affiliated with ABMR Holdings. Please note that ABMR Holdings does not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">6. Accuracy and Completeness</h2>
            <p>
              While we strive to provide accurate and up-to-date information, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">7. Limitation of Liability</h2>
            <p>
              In no event will ABMR Holdings, its affiliates, or their licensors, service providers, employees, agents, officers, or directors be liable for damages of any kind, under any legal theory, arising out of or in connection with your use, or inability to use, the website, any websites linked to it, any content on the website or such other websites, including any direct, indirect, special, incidental, consequential, or punitive damages.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">8. Updates to Disclaimer</h2>
            <p>
              ABMR Holdings may update this disclaimer at any time without notice. By continuing to use this website after any such changes, you accept and agree to the revised disclaimer.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">9. Governing Law</h2>
            <p>
              This disclaimer shall be governed by and construed in accordance with the laws of the United States and the State of Massachusetts, without regard to its conflict of law provisions.
            </p>
            
            <h2 className="text-xl font-semibold mt-8 mb-4">10. Contact Information</h2>
            <p>
              If you have any questions about this disclaimer, please contact us at contact@abmrholdings.com.
            </p>
          </div>
        </motion.div>
      </div>

      {/* Footer */}
      <footer className="relative z-10 px-6 py-8 bg-gray-100 border-t border-gray-200">
        <div className="container mx-auto text-center text-gray-500 text-sm">
          <p>© {new Date().getFullYear()} ABMR Holdings Family Office. All rights reserved.</p>
          <div className="mt-4 space-x-4">
            <button onClick={() => navigate('/privacy-policy')} className="text-[#7000FF] hover:text-[#00FFC6] transition-colors">Privacy Policy</button>
            <button onClick={() => navigate('/terms-of-service')} className="text-[#7000FF] hover:text-[#00FFC6] transition-colors">Terms of Service</button>
            <button onClick={() => navigate('/disclaimer')} className="text-[#7000FF] hover:text-[#00FFC6] transition-colors">Disclaimer</button>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Disclaimer;
